"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rchash = void 0;
const cafe_utility_1 = require("cafe-utility");
const http_1 = require("../utils/http");
const RCHASH_ENDPOINT = 'rchash';
async function rchash(requestOptions, depth, anchor1, anchor2) {
    const response = await (0, http_1.http)(requestOptions, {
        responseType: 'json',
        url: `${RCHASH_ENDPOINT}/${depth}/${anchor1}/${anchor2}`,
    });
    const body = cafe_utility_1.Types.asObject(response.data, { name: 'response.data' });
    return cafe_utility_1.Types.asNumber(body.durationSeconds, { name: 'durationSeconds' });
}
exports.rchash = rchash;
